import Filters from "./Filters";
import Products from "./Products";
import {useEffect, useState} from "react";
import {useLocation, useSearchParams} from "react-router-dom";
import {getSuffixByCount} from "../../utils/Utils";
import Pagination from "../core/Pagination";
import {CatalogFilterInterface} from "../../interfaces/catalog/CatalogFilterInterface";
import {useDebounce} from "@uidotdev/usehooks";
import useCatalog from "./useCatalog";
import {RangeFilterInterface} from "../../interfaces/core/RangeFilterInterface";
import {TopItem} from "./TopItem";
import {ApiResponseInterface as CatalogApiResponseInterface} from "../../interfaces/catalog/ApiResponseInterface";
import {formatBoldText} from "../../utils/formatBoldText";
import {DEFAULT_SORT, isSortType, RELEVANCE_SORT, SortType} from "../../utils/productSort";

export default function CatelogBase({response, header, baseUrl, defaultSort = DEFAULT_SORT} : {response: CatalogApiResponseInterface, header: string, baseUrl: string, defaultSort?: SortType}) {

    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [productsPerPage, ] = useState(36);
    const [additionalPages, setAdditionalPages] = useState(0);
    const [filters, setFilters] = useState<CatalogFilterInterface>({price: {min: 0, max: 0}, filters: {}, brands: []});
    const [productsCount, setProductsCount] = useState(0);
    const debouncedFilters = useDebounce(filters, 500);
    const [searchParams, setSearchParams] = useSearchParams();

    const sortParam = searchParams.get('st');
    const sortType: SortType = isSortType(sortParam) ? sortParam : defaultSort;

    const changeSort = (newSortType: SortType) => {
        if (newSortType === sortType) return;
        const params = new URLSearchParams(searchParams);
        newSortType === defaultSort ? params.delete('st') : params.set('st', newSortType);
        params.delete('page');
        setSearchParams(params, {preventScrollReset: true});
        setPage(1);
        setAdditionalPages(0);
    }

    const {
        getFilteredProducts,
        getProductsOnPage,
        getUniqueBrands,
        getPriceFilter
    } = useCatalog(response, filters, productsPerPage, page, additionalPages, sortType);

    useEffect(() => {
        setPage(1);
        setAdditionalPages(0);
        setProductsCount(response?.products?.length || 0);
        // setSearchParams({page: '1'})
    }, [response?.products]);

    useEffect(() => {
        setProductsCount(getFilteredProducts().length || 0);
        setPage(1);
        setAdditionalPages(0);
    }, [debouncedFilters]);

    const totalPages = Math.ceil(productsCount / productsPerPage);

    const toggleFilters = () => {
        setIsFiltersOpen(!isFiltersOpen);
    }

    return (<div className="catalog">
        <div className="container">
            <div className="bs-head catalog__head">
                <h1>{formatBoldText(header)}</h1>
                {response?.products && response?.products.length > 0 &&
                    <p>{productsCount} товар{getSuffixByCount(productsCount)}</p>}
            </div>
            <div className="mb-4 category mb-lg-5">
                <div className="gx-3 gx-md-6 row gy-7">
                    {response?.subCategories?.map((category, index) => <TopItem key={index} category={category}/>)}
                </div>
            </div>
            <div
                className={'gx-3 gx-md-6 row gy-7 ' + (totalPages > 1 ? '' : ' mb-5 ') + (isFiltersOpen && ' open-filter')}>
                {response?.products && response?.products?.length > 0 &&<Filters
                    priceFilter={getPriceFilter() as RangeFilterInterface}
                    filters={response?.filters || []}
                    brands={getUniqueBrands() || []}
                    toggleFilters={toggleFilters} setFilters={setFilters}
                    productCount={productsCount}
                />}

                {response?.products && response?.products?.length > 0 &&
                    <Products products={getProductsOnPage()} toggleFilters={toggleFilters} sortType={sortType}
                              setSortType={changeSort} withRelevance={defaultSort === RELEVANCE_SORT}/>}
                {totalPages > 1 &&
                    <Pagination page={page} totalPages={totalPages} setPage={setPage} additionalPages={additionalPages}
                                setAdditionalPages={setAdditionalPages}
                                baseUrl={baseUrl}
                                queryString={sortType !== defaultSort ? 'st=' + sortType : ''}/>}
                {response?.products && response?.products?.length === 0 && <h2 className={'text-center text-bg-light border-1 border-top pt-4'}>Товары не найдены</h2>}
            </div>
        </div>
    </div>)
}